<template>
  <div class="mb-md max-w-content mx-auto flex flex-col">
    <div
      class="max-laptop:flex-col gap-xxl px-md pt-lg laptop:rounded-md laptop:my-md flex items-center justify-center bg-blue-50"
    >
      <div class="gap-lg flex flex-col">
        <div class="gap-lg max-laptop:flex-col flex items-center">
          <Icon name="app:agenda-app" class="text-9xl" />

          <p class="font-josefin text-6xl font-bold">Agenda.org</p>
        </div>

        <p class="text-large font-semibold">
          Trouver les sorties et activités proposées autour de vous
        </p>

        <div
          class="max-laptop:flex-col gap-lg flex items-center justify-center"
        >
          <NuxtLink
            class="p-xxs flex items-center"
            to="https://play.google.com/store/apps/details?id=com.sopheos.agenda&utm_source=org&utm_medium=referral&utm_campaign=app_install&utm_content=home"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              src="~/assets/images/google-play.png"
              :alt="`Télécharger l'application Agenda.org sur GooglePlay - ouvre une nouvelle fenêtre`"
              class="max-w-56"
            />
          </NuxtLink>

          <NuxtLink
            class="p-xxs flex items-center"
            to="https://apps.apple.com/fr/app/apple-store/id6793108859?pt=96893923&ct=app_install_org_home&mt=8"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              src="~/assets/images/app-store.png"
              :alt="`Télécharger l'application Agenda.org sur AppStore - ouvre une nouvelle fenêtre`"
              class="max-w-56"
            />
          </NuxtLink>
        </div>
      </div>
      <div>
        <img
          src="~/assets/images/illustrations/app.png"
          alt="Agenda.org applicaiton"
          class="max-h-[750px]"
        />
      </div>
    </div>

    <div class="gap-sm mt-md flex flex-wrap justify-center">
      <template v-for="(agenda, index) in data">
        <div
          v-if="agenda.isActive"
          :key="`agenda-${index}`"
          class="gap-md p-md laptop:max-w-[calc(1/3*100%-24px)] relative grid min-h-[210px] w-full grid-rows-3 justify-center text-center shadow-md hover:bg-blue-100 hover:shadow-lg active:bg-blue-50"
        >
          <NuxtLink
            class="row-span-3 after:absolute after:top-0 after:right-0 after:bottom-0 after:left-0"
            :to="{
              path: agenda.url,
              query: authStore.isControlled
                ? {
                    access_token: tokenStore.access.token,
                    access_expire: useTimestampToUnix(tokenStore.access.exp),
                  }
                : null,
            }"
            external
          >
            <img
              :src="`/logos/${agenda.id}.png`"
              class="mx-auto"
              :alt="`${agenda.domain}`"
            />
            <span class="text-large block first-letter:uppercase">
              {{ agenda.title }}
            </span>
          </NuxtLink>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup>
useInit();

definePageMeta({
  header: "default",
  footer: "default",
});

useHead({
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify(
        [
          {
            operatingSystem: "Android",
            applicationCategory: "TravelApplication",
            installUrl:
              "https://play.google.com/store/apps/details?id=com.sopheos.agenda",
            sameAs:
              "https://play.google.com/store/apps/details?id=com.sopheos.agenda",
          },
          {
            operatingSystem: "iOS",
            applicationCategory: "LifestyleApplication",
            installUrl: "https://apps.apple.com/fr/app/id6793108859",
            sameAs: "https://apps.apple.com/fr/app/id6793108859",
          },
        ].map((app) => ({
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          name: "Agenda.org",
          description: "Le partenaire de vos sorties",
          url: "https://agenda.org/",
          image: "https://agenda.org/logos/logo.png",
          inLanguage: "fr",
          ...app,
          offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
          author: { "@type": "Organization", name: "Sopheos" },
          publisher: {
            "@type": "Organization",
            name: "Le Réseau des Agendas",
            url: "https://agenda.org/",
          },
        })),
      ),
    },
  ],
});

// Data -------------------------------------------------------------------------------------------
const authStore = useAuthStore();
const tokenStore = useTokenStore();

const { data } = await useFetchAgendas();
</script>
